"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var FooterMaker_1 = __importDefault(require("./FooterMaker"));
var HeaderMaker_1 = __importDefault(require("./HeaderMaker"));
var RowMaker_1 = __importDefault(require("./RowMaker"));
var makeTable = function (tableConf) {
    var _a;
    var _b = (_a = tableConf.config) !== null && _a !== void 0 ? _a : {}, noFooter = _b.noFooter, selector = _b.selector, defaultSort = _b.defaultSort;
    if (!selector) {
        throw Error('Unified Table generator requires a selector in table configuration. See TableConf[\'config\']');
    }
    var Header = (0, HeaderMaker_1.default)(tableConf);
    var Row = (0, RowMaker_1.default)(tableConf);
    var Footer = !noFooter && (0, FooterMaker_1.default)(tableConf);
    var GeneratedTable = function (_a) {
        var filterFunction = _a.filterFunction, children = _a.children, props = __rest(_a, ["filterFunction", "children"]);
        var items = (0, react_redux_1.useSelector)(selector);
        var filteredItems = (0, react_1.useMemo)(function () { var _a; return (_a = filterFunction === null || filterFunction === void 0 ? void 0 : filterFunction(items)) !== null && _a !== void 0 ? _a : items; }, [items, filterFunction]);
        var sortedItems = (0, hooks_1.useSortArray)(filteredItems, tableConf.extractors);
        if (!(0, react_redux_firebase_1.isLoaded)(filteredItems) || !(0, react_redux_firebase_1.isLoaded)(sortedItems)) {
            return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
        }
        return ((0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ maxWidth: 1400, px: 4, ml: -2 }, props, { children: [(0, jsx_runtime_1.jsx)(Header, { count: sortedItems.length }), (0, jsx_runtime_1.jsx)(TableBody_1.default, __assign({ width: "100%" }, { children: sortedItems.map(function (item) {
                        var _a, _b;
                        return ((0, jsx_runtime_1.jsx)(Row, { item: item, hoverable: (_a = tableConf.row) === null || _a === void 0 ? void 0 : _a.hoverable, highlightInputs: (_b = tableConf.row) === null || _b === void 0 ? void 0 : _b.highlightInputs }, item.id));
                    }) })), Footer && (0, jsx_runtime_1.jsx)(Footer, { items: filteredItems }), children] })));
    };
    return (0, SortHoC_1.default)(GeneratedTable, defaultSort);
};
exports.default = makeTable;
